import React from "react";
import { Box } from "@mui/material";
import { WORKSUITE_BRAND } from "./brandAuthority";

export default function WorksuiteLoginBrandLogo({ sx, alt = "Worksuite" }) {
  return <Box component="img" src={WORKSUITE_BRAND.loginLogo} alt={alt} sx={{ display: "block", objectFit: "contain", ...sx }} />;
}
